// leave off @2x/@3x
const images = {
  icon_hand_wash: require("../images/icons/icon_hand_wash.png"),
  icon_rinse: require("../images/icons/icon_rinse.png"),
  icon_towel: require("../images/icons/icon_towel.png"),
  icon_polish: require("../images/icons/icon_polish.png"),
  icon_squeegee: require("../images/icons/icon_squeegee.png"),
  icon_vacuum: require("../images/icons/icon_vacuum.png"),
  icon_car_wheel: require("../images/icons/icon_car_wheel.png"),
  icon_car_tire: require("../images/icons/icon_car_tire.png"),
  icon_car_mat: require("../images/icons/icon_car_mat.png"),
  icon_spray_bottle: require("../images/icons/icon_spray_bottle.png"),
  icon_cleaning: require("../images/icons/icon_cleaning.png"),
  icon_sill: require("../images/icons/icon_sill.png"),
  icon_dry: require("../images/icons/icon_dry.png"),
  icon_leather: require("../images/icons/icon_leather.png"),
  icon_bottle: require("../images/icons/icon_bottle.png"),
  icon_clay_bar: require("../images/icons/icon_clay_bar.png"),
  icon_carpet_clean: require("../images/icons/icon_carpet_clean.png"),

  icon_bank: require("../images/icons/icon_bank.png"),
  icon_customers: require("../images/icons/icon_customers.png"),
  icon_money: require("../images/icons/icon_money.png"),
  icon_realtime: require("../images/icons/icon_realtime.png"),
  icon_work: require("../images/icons/icon_work.png"),
  icon_workload: require("../images/icons/icon_workload.png")
};

export default images;



// WEBPACK FOOTER //
// ./src/theme/Images.js